import { Analytics } from "./Analytics";
import { AhoyProvider } from "./providers/ahoyProvider";
import { AnalyticsConfig } from "./types";

let analyticsInstance: Analytics | null = null;

export function initializeAnalytics(config?: Partial<AnalyticsConfig>): Analytics {
  if (!analyticsInstance) {
    const ahoyProvider = new AhoyProvider();

    analyticsInstance = new Analytics({
      providers: [ahoyProvider],
      enabled: config?.enabled !== false,
      ...config,
    });
  }

  return analyticsInstance;
}

export function getAnalytics(): Analytics {
  if (!analyticsInstance) {
    return initializeAnalytics();
  }
  return analyticsInstance;
}
